import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ChipDto } from '../../api/models';

export const ChipsActions = createActionGroup({
  source: 'Chips',
  events: {
    'Load Available Chips': emptyProps(),
    'Load Available Chips Success': props<{ availableChips: ChipDto[] }>(),
    'Load Available Chips Failure': props<{ error: unknown }>(),
    'Load All Chips': emptyProps(),
    'Load All Chips Success': props<{ allChips: ChipDto[] }>(),
    'Load All Chips Failure': props<{ error: unknown }>(),
    'Create Chip': props<{ chipNr: string }>(),
    'Create Chip Success': props<{ createdChip: ChipDto }>(),
    'Create Chip Failure': props<{ error: unknown }>(),
    'Delete Chip': props<{ chipNr: string }>(),
    'Delete Chip Success': props<{ deletedChipNr: string }>(),
    'Delete Chip Failure': props<{ error: unknown }>(),
    'Restrict Chip': props<{ chipToBeRestricted: ChipDto }>(),
    'Restrict Chip Success': props<{restrictedChip: ChipDto}>(),
    'Restrict Chip Failure': props<{ error: unknown }>(),
    'Unrestrict Chip': props<{ chipNr: string }>(),
    'Unrestrict Chip Success': props<{ chip: ChipDto }>(),
    'Unrestrict Chip Failure': props<{ error: unknown }>(),
  },
});
